<template>
	<section>
		<el-tabs v-model="activeName" type="card">
			<el-tab-pane label="Single Table" name="first">
				<el-row>
					<el-col :span="24" style="margin-bottom: 40px;margin-top:30px;">
						<el-steps :active="step">
							<el-step title="The First step" description="Select Object"></el-step>
							<el-step title="The Second step" description="Select Conditions"></el-step>
							<el-step title="The Third step" description="Select Display Column"></el-step>
						</el-steps>
					</el-col>
					<el-col :span="24" v-if="step == 0">
						<el-form label-width="160px">
							<el-form-item label="Schema">
								<el-select v-model="form.sSchema" style="width:600px;" placeholder="Select" @change="change1">
									<el-option v-for="(item, index) in options" :key="index" :label="item.sSchema" :value="item.sSchema"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="Table" v-if="!!form.sSchema">
								<el-select v-model="form.nSelectId" style="width:600px;" placeholder="Select">
									<el-option v-for="(item, index) in options2" :key="index" :label="item.sName" :value="item.nSelectId"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item><el-button type="primary" v-on:click="step2">The Next Step</el-button></el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 2">
						<el-form label-width="160px">
							<el-form-item label="Table">{{ form.sName }}</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="index">
								<el-select v-model="item.sColumnCode" placeholder="Select" clearable @change="change2(item)">
									<el-option v-for="item in options3" :key="item.sColumnCode" :label="item.sColumnName" :value="item.sColumnCode"></el-option>
								</el-select>
								<el-select v-model="item.fuhao" placeholder="Select">
									<el-option
										v-for="a in options4"
										v-if="item.type == 'Datetime' && (a.id == 'in' || a.id == 'not in') ? 0 : 1"
										:key="a.id"
										:label="a.name"
										:value="a.id"
									></el-option>
								</el-select>
								<!-- <el-input
									style="width:400px;"
									v-if="
										form.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Event' ||
											form.sSelectName == 'T_EDW_FACT_Evtitm_Event_All' ||
											form.sSelectName == 'T_EDW_Trace_FACT_Evtitm_Item'
									"
									v-model="item.value[0]"
									:placeholder="item.type"
								></el-input> -->
								<el-select
									v-model="item.value"
									style="width:400px;"
									multiple
									:multiple-limit="item.fuhao == 'in' || item.fuhao == 'not in' ? 0 : 1"
									v-if="item.type != 'Datetime' && form.sSelectName != 'T_EDW_FACT_Evtitm_Event_All'"
									filterable
									remote
									reserve-keyword
									:placeholder="item.type"
									:data-id="index"
									:remote-method="querySearchAsync"
									:loading="loading"
								>
									<el-option v-for="item in item.options" :key="item" :label="item" :value="item"></el-option>
								</el-select>
								<el-input
									v-model="item.value"
									v-else-if="item.type != 'Datetime' && form.sSelectName == 'T_EDW_FACT_Evtitm_Event_All'"
									style="width:400px;"
								></el-input>
								<el-date-picker
									v-else="item.type == 'Datetime'"
									style="padding:0;"
									format="yyyy-MM-dd HH:mm:ss"
									value-format="yyyy-MM-dd HH:mm:ss"
									prefix-icon="xxx"
									v-model="item.value[0]"
									type="datetime"
									:placeholder="item.type"
								></el-date-picker>
								<el-button type="button" v-if="index == 0" v-on:click="addList(form.sSelectFilter)">Add+</el-button>
								<el-button v-if="index > 0" type="button" v-on:click="deleteList(form.sSelectFilter, index)">Delete-</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="step1">The Prev Step</el-button>
								<el-button type="primary" v-on:click="step3">The Next Step</el-button>
							</el-form-item>
						</el-form>
					</el-col>
					<el-col :span="24" v-if="step == 4">
						<el-form label-width="160px">
							<el-form-item label="Table">{{ form.sName }}</el-form-item>
							<el-form-item :label="'Condition.' + (index + 1)" v-for="(item, index) in form.sSelectFilter" :key="index">
								<span class="span-label">{{ item.sColumnName }}</span>
								<label>{{ item.fuhao }}</label>
								<span class="span-label">{{ arrToString(item.value) }}</span>
							</el-form-item>
							<el-form-item label="Columns">
								<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
								<div style="margin: 15px 0;"></div>
								<el-checkbox-group v-model="form.sSelectFieldName" @change="handleCheckedCitiesChange">
									<el-checkbox v-for="a in options3" :label="a.sColumnCode" :key="a.sColumnCode">{{ a.sColumnName }}</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
							<el-form-item>
								<el-button type="button" v-on:click="step2">The Prev Step</el-button>
								<el-button type="primary" v-on:click="toData2">OK</el-button>
							</el-form-item>
						</el-form>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<el-dialog title="Display result" :visible.sync="dialogVisible" width="80%">
			<div style="font-size: 20px;" v-if="count < 1000000">
				<label>Row Count.</label>
				<span class="span-label">{{ count }}</span>
				<el-button v-on:click="showListFlag = !showListFlag">{{ showListFlag == true ? 'Hide' : 'Display' }}</el-button>
				<el-button v-on:click="addDownLoad">
					Download
					<span v-if="timer > 0">({{ timer }})</span>
				</el-button>
			</div>
			<div v-if="showListFlag" style="border-top:1px solid #eee;margin-top:20px;">
				<el-table ref="multipleTable" height="500px" :data="tableData" tooltip-effect="dark" style="width: 100%">
					<el-table-column width="200" v-for="(item,index) in form.sSelectFieldName" :key="index" :formatter="timeFormatter" :prop="item" :label="item"></el-table-column>
				</el-table>
			</div>
			<div style="font-size: 20px;padding:10px 0;" v-if="count >= 1000000">
				<h2>
					<label>Row Count.</label>
					<span class="span-label">{{ count }}</span>
					Too much data,unable to export!
				</h2>
			</div>
			<!--<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">Confirm</el-button>
			</span>-->
		</el-dialog>
	</section>
</template>

<script>
import {
	getSchemaNameList,
	getDynamicSQL,
	selectExColumnValueBynSelectId,
	addDownloadExport,
	selectColumnValueBynSelectId,
	getDatabaseInfoList,
	addSelectView,
	getSelectList,
	getSelectColumnList,
	getDynamicColumnList
} from '../../api/api';
import util from '../../api/util.js';
export default {
	data() {
		return {
			step: 0,
			form: {
				sName: '',
				sSchema: '',
				sSchemaName: '',
				sSelectName: '',
				nSelectId: '',
				sSelectFilter: [],
				sSelectFieldName: []
			},
			dialogVisible: false,
			checkAll: false,
			isIndeterminate: true,
			activeName: 'first',
			options: [],
			options2: [],
			options3: [],
			options4: [
				{
					id: 'in',
					name: '='
				},
				{
					id: '>',
					name: '>'
				},
				{
					id: '>=',
					name: '>='
				},
				{
					id: '<',
					name: '<'
				},
				{
					id: '<=',
					name: '<='
				},
				{
					id: 'not in',
					name: '!='
				}
			],
			options5: [],
			index: 0,
			loading: false,
			tableData: [],
			showListFlag: false,
			count: 0,
			sql: {
				table: '',
				ziduan: '',
				tiaojian: ''
			},
			favortFlag: false,
			timer: 0
		};
	},
	mounted() {
		getDatabaseInfoList({
			currentPage: 1,
			pageSize: 9999
		}).then(res => {
			this.options = res.data;
		});
		//this.change1();
	},
	methods: {
		timeFormatter(row, column) {
			var shuju = row[column.property];
			try {
				if (shuju.indexOf('T') > -1) {
					var times = new Date(shuju);
					if (times == 'Invalid Date') {
						return shuju;
					}
					return util.formatDate.format(times, 'yyyy-MM-dd hh:mm:ss');
				} else {
					return shuju;
				}
			} catch (e) {
				return shuju;
			}
		},
		arrToString(arr) {
			try {
				return arr.join(',');
			} catch (e) {
				return arr;
			}
		},
		addList(item) {
			item.push({
				sColumnCode: '',
				sColumnName: '',
				fuhao: '',
				options: [],
				value: [],
				type: ''
			});
		},
		deleteList(item, index) {
			item.splice(index, 1);
		},
		querySearchAsync(queryString) {
			this.options5 = [];
			var index = 0;
			try {
				var node = window.getSelection().focusNode.parentElement;
				index = node.getAttribute('data-id');
			} catch (e) {
				//TODO handle the exception
			}
			if (!this.form.sSelectFilter[index]['sColumnCode']) {
				this.$message.error('Please select the Condition Code');
				return;
			}
			if (queryString != '') {
				this.loading = true;
				selectColumnValueBynSelectId({
					nSelectId: this.form.nSelectId,
					sColumnCode: this.form.sSelectFilter[index]['sColumnCode']
				}).then(res => {
					if (res.data.length === 0) {
						getDynamicColumnList({
							currentPage: 1,
							sColumnCode: this.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: this.form.sSchemaName,
							sSelectName: this.form.sSelectName,
							pageSize: 9999
						}).then(res => {
							var arr = [];
							for (var i = 0; i < res.data.length; i++) {
								arr.push(res.data[i][this.form.sSelectFilter[index]['sColumnCode']]);
							}
							this.loading = false;
							this.form.sSelectFilter[index].options = arr;
						});
					} else {
						getDynamicColumnList({
							currentPage: 1,
							sColumnCode: this.form.sSelectFilter[index]['sColumnCode'],
							sColumnValue: queryString,
							sSchemaName: this.form.sSchemaName,
							sSelectName: this.form.sSelectName,
							pageSize: 9999
						}).then(res2 => {
							var arr = [];
							for (var i = 0, len = res.data.length; i < len; i++) {
								for (var j = 0, len2 = res2.data.length; j < len2; j++) {
									if (res.data[i]['sColumnValue'] == res2.data[j][this.form.sSelectFilter[index]['sColumnCode']]) {
										arr.push(res.data[i]['sColumnValue']);
									}
								}
							}
							this.loading = false;
							this.form.sSelectFilter[index].options = arr;
						});
					}
				});
			}
		},
		change2(item) {
			for (var i = 0; i < this.options3.length; i++) {
				if (this.options3[i]['sColumnCode'] == item.sColumnCode) {
					item.type = this.options3[i]['sColumnType'];
					item.sColumnName = this.options3[i]['sColumnName'];
				}
			}
			if (item.sColumnCode == '') {
				item.fuhao = '';
				item.value = [];
				item.options = [];
			}
		},
		change1() {
			getSelectList({
				currentPage: 1,
				nSelectType: 1,
				sSchema: this.form.sSchema,
				pageSize: 9999
			}).then(res => {
				this.options2 = res.data;
			});
		},
		step1() {
			this.step = 0;
		},
		step2() {
			for (var i = 0; i < this.options2.length; i++) {
				if (this.options2[i]['nSelectId'] == this.form.nSelectId) {
					this.form.sName = this.options2[i]['sName'];
					this.form.sSelectName = this.options2[i]['sSelectName'];
					this.form.sSchemaName = this.options2[i]['sSchemaName'];
				}
			}
			if (!this.form.nSelectId) {
				this.$message.error('Please select the Table');
				return;
			}
			getSelectColumnList({
				currentPage: 1,
				nSelectId: this.form.nSelectId,
				pageSize: 9999
			}).then(res => {
				this.options3 = res.data;
				if (this.form.sSelectFilter.length == 0) {
					this.form.sSelectFilter = [
						{
							sColumnCode: '',
							sColumnName: '',
							fuhao: '',
							options: [],
							value: [],
							type: ''
						}
					];
				}
				this.step = 2;
			});
		},
		step3() {
			if (this.form.sSelectFilter.length == 1) {
				//当数组只有一个的时候 切都不存在的时候
				if (!this.form.sSelectFilter[0]['sColumnCode'] && !this.form.sSelectFilter[0]['fuhao'] && this.form.sSelectFilter[0]['value'].length == 0) {
					this.form.sSelectFilter.splice(0, 1);
					this.step = 4;
					return;
				}
			}
			var flag = false;
			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (!this.form.sSelectFilter[i]['sColumnCode']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (!this.form.sSelectFilter[i]['fuhao']) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
				if (this.form.sSelectFilter[i]['value'].length == 0) {
					this.$message.error('Please select the Condition');
					flag = true;
					return;
				}
			}
			if (flag == true) {
				return;
			} else {
				this.step = 4;
			}
		},
		toData2() {
			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.$prompt('Enter file name', 'Tips', {
				confirmButtonText: 'Confirm',
				cancelButtonText: 'Cancel',
				inputPattern: /\S/,
				inputErrorMessage: 'Enter file name'
			})
				.then(({ value }) => {
					selectExColumnValueBynSelectId({
						nSelectId: this.form.nSelectId
					}).then(res => {
						var arr = [];
						res.data.forEach(one => {
							arr.push(this.form.sSchemaName + '.' + this.form.sSelectName + '.' + one.sColumnCode + ' in(' + one.sColumnValue + ')');
						});
						this.pinjiesql(arr);
						addDownloadExport({
							sSchema: this.form.sSchema,
							sSelectName: this.sql.table,
							sSelectFieldName: this.sql.ziduan,
							sSelectFilter: this.sql.tiaojian,
							sFileName: value + '.csv',
							sContent: JSON.stringify(this.form),
							sFavorite: 0,
							nType: 1
						}).then(res => {
							this.$message('download success！');
						});
					});
				})
				.catch(() => {});
		},
		pinjiesql(duoyuarr) {
			this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
			var arr = [];
			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.form.sSelectFieldName[i]);
			}
			this.sql.ziduan = arr.join(',');
			var arr = [];

			var arrToyinhao = function(arr, type) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(
						this.sql.table +
							'.' +
							this.form.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.form.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.form.sSelectFilter[i]['value'], this.form.sSelectFilter[i]['type']).join(',') +
							')'
					);
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(
							this.sql.table +
								'.' +
								this.form.sSelectFilter[i]['sColumnCode'] +
								this.form.sSelectFilter[i]['fuhao'] +
								"N'"+
								this.form.sSelectFilter[i]['value'][j] +
								"'"
						);
					}
				}
			}
			arr = arr.concat(duoyuarr);
			this.sql.tiaojian = arr.join(' and ');
		},
		toData() {
			if (this.form.sSelectFieldName.length == 0) {
				this.$message.error('Please select the Columns');
				return;
			}
			this.sql.table = this.form.sSchemaName + '.' + this.form.sSelectName;
			var arr = [];

			for (var i = 0; i < this.form.sSelectFieldName.length; i++) {
				arr.push(this.sql.table + '.' + this.form.sSelectFieldName[i]);
			}

			this.sql.ziduan = arr.join(',');
			var arr = [];

			var arrToyinhao = function(arr, type) {
				var _arr = [];
				for (var i = 0; i < arr.length; i++) {
					_arr.push("N'" + arr[i] + "'");
				}
				return _arr;
			};

			for (var i = 0; i < this.form.sSelectFilter.length; i++) {
				if (this.form.sSelectFilter[i]['fuhao'] == 'in' || this.form.sSelectFilter[i]['fuhao'] == 'not in') {
					arr.push(
						this.sql.table +
							'.' +
							this.form.sSelectFilter[i]['sColumnCode'] +
							' ' +
							this.form.sSelectFilter[i]['fuhao'] +
							'(' +
							arrToyinhao(this.form.sSelectFilter[i]['value'],this.form.sSelectFilter[i]['type']).join(',') +
							')'
					);
				} else {
					for (var j = 0; j < this.form.sSelectFilter[i]['value'].length; j++) {
						arr.push(
							this.sql.table +
								'.' +
								this.form.sSelectFilter[i]['sColumnCode'] +
								this.form.sSelectFilter[i]['fuhao'] +
								"N'"+
								this.form.sSelectFilter[i]['value'][j] +
								"'"
						);
					}
				}
			}
			this.sql.tiaojian = arr.join(' and ');
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			getDynamicSQL({
				sSelectName: this.sql.table,
				sSelectFieldName: this.sql.ziduan,
				sSelectFilter: this.sql.tiaojian,
				sSchemaName: this.form.sSchemaName,
				currentPage: 1,
				pageSize: 100
			})
				.then(res => {
					loading.close();
					this.count = res.page.totalCount * 1;
					this.tableData = res.data;
					this.favortFlag = false;
					this.timer = 0;
					this.dialogVisible = true;
				})
				.catch(res => {
					loading.close();
				});
		},
		handleCheckAllChange(flag) {
			if (flag == true) {
				var arr = [];
				for (var i = 0; i < this.options3.length; i++) {
					arr.push(this.options3[i]['sColumnCode']);
				}
				this.form.sSelectFieldName = arr;
			} else {
				this.form.sSelectFieldName = [];
			}
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.options3.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.options3.length;
		},
		addDownLoad() {
			if (this.timer == 0) {
				this.$prompt('Enter file name', 'Tips', {
					confirmButtonText: 'Confirm',
					cancelButtonText: 'Cancel',
					inputPattern: /\S/,
					inputErrorMessage: 'Enter file name'
				})
					.then(({ value }) => {
						addDownloadExport({
							sSchema: this.form.sSchema,
							sSelectName: this.sql.table,
							sSelectFieldName: this.sql.ziduan,
							sSelectFilter: this.sql.tiaojian,
							sFileName: value + '.csv',
							sContent: JSON.stringify(this.form),
							sFavorite: 0,
							nType: 1,
							sStatus: 0
						}).then(res => {
							this.timer = 60;
							var _this = this;
							var T = setInterval(function() {
								_this.timer--;
								if (_this.timer == 1) {
									clearInterval(T);
									setTimeout(function() {
										_this.timer = 0;
									}, 1000);
								}
							}, 1000);
						});
					})
					.catch(() => {});
			}
		}
	}
};
</script>

<style></style>



// WEBPACK FOOTER //
// single.vue?12605e01